import ko from 'knockout';
import tinymce from 'libraries/tinymce.js';

const template = `
<textarea
    class="form-control"
    data-bind="attr: {id: id, name: id}
"></textarea>`;

class EditorModel {
    constructor(params, elem) {
        if (!params.value || !ko.isObservable(params.value)) {
            throw new Error('mce-editor requires an observable "value" param');
        }
        this.value = params.value;
        if (params.id) {
            this.id = ko.unwrap(params.id);
        } else {
            this.id = `mce-editor-${Math.round(Math.random() * 1000)}`;
        }

        elem = elem.querySelector('textarea');
        elem.textContent = this.value();

        const skin = params.skin || 'lightgray';
        const toolbar = params.toolbar || 'bold italic | bullist numlist';
        const settings = {
            branding: false,
            browser_spellcheck: true,
            menubar: false,
            plugins: 'paste lists',
            resize: false,
            skin_url: `${window.STATIC_URL}style/libraries/tinymce/skins/${skin}`,
            statusbar: false,
            toolbar,
            valid_elements: 'a[href],b/strong,i/em,ul,ol,li,p,br',
        };

        this.setupEditor(elem, settings);

        const valSub = this.value.subscribe((val) => {
            if (this.ignoreUpdate) {
                this.ignoreUpdate = false;
            } else {
                this.editor.setContent(val);
            }
        });

        ko.utils.domNodeDisposal.addDisposeCallback(elem, () => {
            this.editor.remove();
            valSub.dispose();
        });
    }

    async setupEditor(elem, settings) {
        const editors = await tinymce.init({
            target: elem,
            ...settings,
        });
        this.editor = editors[0];

        this.editor.on('change keyup nodechange', () => {
            const val = this.editor.getContent();
            if (val !== this.value.peek()) {
                this.ignoreUpdate = true;
                this.value(val);
            }
        });
    }
}

ko.components.register('mce-editor', {
    viewModel: {
        createViewModel(params, info) {
            return new EditorModel(params, info.element);
        },
    },
    template,
});
